import { Check, X, Loader2 } from "lucide-react";
import { MicButton } from "@/components/MicButton";

export const PleaseGate = ({ age, check, text, setText, onRecheck, loading }) => (
  <section className="pp-card gate-blocked" data-testid="please-gate-card">
    <p className="pp-label">Step 2 · The Please Gate</p>
    <div className="pp-gate-head">
      <span className="pp-lock"><X className="h-6 w-6" /></span>
      <h2 className="pp-h2">
        {age === "kid" ? "Oops! The magic word is missing." : "Hold on — no “please” detected."}
      </h2>
    </div>
    <p className="pp-quote" data-testid="original-directive-text">“{text}”</p>
    <div className="pp-meters">
      <div className={`pp-chip ${check.has_please ? "ok" : "no"}`} data-testid="please-status">
        {check.has_please ? <Check className="h-4 w-4" /> : <X className="h-4 w-4" />} Please
      </div>
    </div>
    <p className="pp-feedback" data-testid="coaching-feedback-text">{check.feedback}</p>
    {check.polished && (
      <div className="pp-fix">
        <p className="pp-label">An idea to try (say or type it yourself)</p>
        <p data-testid="polished-suggestion-text">“{check.polished}”</p>
      </div>
    )}
    <textarea
      data-testid="gate-retry-textarea"
      className="pp-textarea"
      rows={2}
      value={text}
      onChange={(e) => setText(e.target.value)}
    />
    <div className="pp-actions">
      <MicButton testId="gate-retry-mic-button" onText={setText} label="Say it again" />
      <button data-testid="recheck-manners-button" className="pp-primary" disabled={loading} onClick={onRecheck}>
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Try again"}
      </button>
    </div>
  </section>
);
